import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Student Utilities and Constants
 */

/**
 * Returns the tailwind badge color classes for a student status.
 */
export const getStatusBadgeColor = (status: string): string => {
    switch (status) {
        case 'active':
            return 'bg-green-100 text-green-800';
        case 'inactive':
            return 'bg-yellow-100 text-yellow-800';
        case 'graduated':
            return 'bg-blue-100 text-blue-800';
        default:
            return 'bg-gray-100 text-gray-800';
    }
};

/**
 * Auto-suggests an email based on first name, last name, and a 3-4 digit random number.
 */
export const generateEmailSuggestion = (firstName: string, lastName: string): string => {
    const cleanFirst = firstName.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    const cleanLast = lastName.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    
    if (!cleanFirst) return '';
    
    // Generate a random 4-digit number (e.g. 1000 - 9999)
    const randomNumber = Math.floor(1000 + Math.random() * 9000);
    
    return `${cleanFirst}${cleanLast}${randomNumber}@gmail.com`;
};

/**
 * Get all students associated with a specific badge title
 */
export const getStudentsWithBadge = async (badgeTitle: string): Promise<any[]> => {
    try {
        const studentsRef = collection(db, 'students');
        const q = query(studentsRef, where('academicInfo.badge', '==', badgeTitle));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error('Error fetching students with badge:', error);
        return [];
    }
};

